import { CSSResultGroup, html, LitElement, nothing, TemplateResult } from 'lit'
import { customElement } from 'lit/decorators.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { consume } from '@lit/context'
import {
  activeQuotationContext,
  NotFetchedYet
} from 'components/ordering/quotation/components/context/quotation-context.js'
import { QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { NotFoundError } from 'components/ordering/quotation/api/dtos/error.js'
import { isQuotationDTO } from 'components/ordering/quotation/components/is-quotation-dto.js'
import { hostDisplayContents } from 'components/ordering/quotation/components/quotation.style.js'


const translations = {
  title: () => t('title', {
    ns: 'csc-quotation-request-accepted-banner',
    default: 'This quotation is accepted'
  }),
  description: () => t('description', {
    ns: 'csc-quotation-request-accepted-banner',
    default: 'You will receive an order confirmation by email when the order has been placed.'
  }),
} as const


@customElement('csc-quotation-request-accepted-banner')
export class CSCQuotationRequestAcceptedBanner extends LitElement {
  static override styles: CSSResultGroup = [hostDisplayContents]

  @consume({ context: activeQuotationContext, subscribe: true })
  private quotation!: QuotationDTO | NotFoundError | NotFetchedYet

  private shouldRenderErpBanner() {
    return isQuotationDTO(this.quotation)
      // the merchant has accepted the quotation
      && this.quotation.status === 'accepted'
      // quotations are processed through the erp, not the basket
      && !this.quotation.canAddToBasket
  }

  protected override render(): TemplateResult | typeof nothing {
    if (!this.shouldRenderErpBanner()) return nothing

    return html`
      <cse-alert>
        ${translations.title()}
        <div slot="description">
          ${translations.description()}
        </div>
      </cse-alert>
    `
  }
}
